import { useState, useEffect } from "react";
import {
  TOURS_ENABLED,
  hasTourBeenSeen,
  peekPendingTour,
  consumePendingTour,
} from "@/lib/tourState";
import { ALL_TOURS, type TourDef } from "@/lib/tourConfig";

export function useAppTour(tourId: string) {
  const [activeTour, setActiveTour] = useState<TourDef | null>(null);

  useEffect(() => {
    if (!TOURS_ENABLED) return;

    const timer = setTimeout(() => {
      const pending = peekPendingTour();
      if (pending && pending !== tourId) return;

      let forceFromPending = false;
      if (pending === tourId) {
        consumePendingTour();
        forceFromPending = true;
      }

      if (forceFromPending || !hasTourBeenSeen(tourId)) {
        const def = ALL_TOURS.find((t) => t.id === tourId) ?? null;
        setActiveTour(def);
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [tourId]);

  return {
    activeTour: TOURS_ENABLED ? activeTour : null,
    closeTour: () => setActiveTour(null),
  };
}
